import React from "react";
import PluginPlaceholder from "../../_editor/components/canvas/plugin_placeholder/PluginPlaceholder";
import "./_dragdrop.scss";
import i18n from "i18next";
import { contentT } from "../../common/content_language";
import { setRgbaAlpha } from "../../common/common_tools";
/* eslint-disable react/prop-types */

export function DragDrop(base) {
  return {
    getConfig: function () {
      return {
        name: "DragDrop",
        displayName: IdealStudio.i18n.t("DragDrop.PluginName"),
        category: "evaluation",
        icon: "tab_unselected",
        initialWidth: "100%",
        initialHeight: "100%",
        initialWidthSlide: "100%",
        initialHeightSlide: "100%",
        flavor: "react",
        isComplex: true,
        defaultCorrectAnswer: [0],
        defaultCurrentAnswer: [],
      };
    },
    getToolbar: function (state) {
      return {
        main: {
          __name: "Main",
          accordions: {
            __score: {
              __name: i18n.t("configuration"),
              icon: "build",
              buttons: {
                /* nBoxes: {
                                    __name: i18n.t("DragDrop.Number"),
                                    type: 'number',
                                    value: state.nBoxes,
                                    max: 10,
                                    min: 0,
                                }, */
                showFeedback: {
                  __name: i18n.t("DragDrop.ShowFeedback"),
                  type: "checkbox",
                  checked: state.showFeedback,
                },
                shuffle: {
                  __name: i18n.t("MultipleChoice.Shuffle"),
                  type: "checkbox",
                  checked: state.shuffle,
                },
                buttons: {
                  __name: i18n.t("MultipleChoice.WhichButtons"),
                  type: "radio",
                  value: state.buttons,
                  options: ["tryAgain", "seeAnswer"],
                  labels: [i18n.t("MultipleChoice.tryAgain"), i18n.t("MultipleChoice.seeAnswer")],
                },
              },
            },
            style: {
              __name: IdealStudio.i18n.t("DragDrop.box_style"),
              icon: "palette",
              buttons: {
                padding: {
                  __name: IdealStudio.i18n.t("DragDrop.padding"),
                  type: "number",
                  value: 10,
                  min: 0,
                  max: 100,
                },
                backgroundColor: {
                  __name: IdealStudio.i18n.t("DragDrop.background_color"),
                  type: "color",
                  value: "#ffffff",
                },
                borderWidth: {
                  __name: IdealStudio.i18n.t("DragDrop.border_size"),
                  type: "number",
                  value: 1,
                  min: 0,
                  max: 10,
                },
                borderStyle: {
                  __name: IdealStudio.i18n.t("DragDrop.border_style"),
                  type: "select",
                  value: "solid",
                  options: [
                    "none",
                    "hidden",
                    "dotted",
                    "dashed",
                    "solid",
                    "double",
                    "groove",
                    "ridge",
                    "inset",
                    "outset",
                    "initial",
                    "inherit",
                  ],
                  labels: [
                    i18n.t("styles.border_style_options.none") || "none",
                    i18n.t("styles.border_style_options.hidden") || "hidden",
                    i18n.t("styles.border_style_options.dotted") || "dotted",
                    i18n.t("styles.border_style_options.dashed") || "dashed",
                    i18n.t("styles.border_style_options.solid") || "solid",
                    i18n.t("styles.border_style_options.double") || "double",
                    i18n.t("styles.border_style_options.groove") || "groove",
                    i18n.t("styles.border_style_options.ridge") || "ridge",
                    i18n.t("styles.border_style_options.inset") || "inset",
                    i18n.t("styles.border_style_options.outset") || "outset",
                    i18n.t("styles.border_style_options.initial") || "initial",
                    i18n.t("styles.border_style_options.inherit") || "inherit",
                  ],
                },
                borderColor: {
                  __name: IdealStudio.i18n.t("DragDrop.border_color"),
                  type: "color",
                  value: "#dbdbdb",
                },
                borderRadius: {
                  __name: IdealStudio.i18n.t("DragDrop.radius"),
                  type: "number",
                  value: 0,
                  min: 0,
                  max: 50,
                },
                opacity: {
                  __name: IdealStudio.i18n.t("DragDrop.opacity"),
                  type: "range",
                  value: 1,
                  min: 0,
                  max: 1,
                  step: 0.01,
                },
              },
            },
          },
        },
      };
    },
    getInitialState: function () {
      return {
        nBoxes: 1,
        showFeedback: true,
        shuffle: false,
        buttons: "tryAgain",
      };
    },
    getRenderTemplate: function (state, props = {}) {
      let nBoxes = state.nBoxes || 1;
      let suffix = "";
      for (let i = 0; i < nBoxes; i++) {
        suffix += " {{#" + (i + 1) + "}}";
      }
      let defaultText = "<p>" + contentT("DragDrop.Statement") + suffix + "</p>";

      const answerElements = [];
      for (let i = 0; i < state.nBoxes; i++) {
        answerElements.push(
          <div key={"answer-wrapper-" + i} style={{ position: "relative" }} data-answer-row={i}>
            {props.onMoveAnswer ? (
              <div className="assessment-reorder" contentEditable={false}>
                <button
                  type="button"
                  className="assessment-reorder-btn"
                  aria-label={i18n.t("messages.move_up") || "Move up"}
                  title={i18n.t("messages.move_up") || "Move up"}
                  disabled={i === 0}
                  onClick={(e) => {
                    e.stopPropagation();
                    props.onMoveAnswer(i, -1);
                  }}
                >
                  ▲
                </button>
                <button
                  type="button"
                  className="assessment-reorder-btn"
                  aria-label={i18n.t("messages.move_down") || "Move down"}
                  title={i18n.t("messages.move_down") || "Move down"}
                  disabled={i === state.nBoxes - 1}
                  onClick={(e) => {
                    e.stopPropagation();
                    props.onMoveAnswer(i, 1);
                  }}
                >
                  ▼
                </button>
              </div>
            ) : null}
            <div className={"col-xs-12 feedback"}>
              <PluginPlaceholder
                {...props}
                key={"answer-placeholder-" + i}
                dndIndex={i + 1}
                pluginContainerName={i18n.t("DragDrop.Answer") + " " + (i + 1)}
                pluginDefaultContent={[
                  {
                    plugin: "BasicText",
                    initialState: { __i18nKey: "DragDrop.Answer", __suffix: " " + (i + 1) },
                  },
                ]}
                pluginContainer={"Answer" + i}
              />
            </div>
            {props.onRemoveAnswer ? (
              <button
                type="button"
                className="assessment-remove-answer"
                aria-label={i18n.t("messages.remove_answer")}
                title={i18n.t("messages.remove_answer")}
                onClick={(e) => {
                  e.stopPropagation();
                  props.onRemoveAnswer(i);
                }}
              >
                ×
              </button>
            ) : null}
          </div>
        );
      }

      return (
        <div className={"exercisePlugin dragdropPlugin"}>
          <div className={"row"} key={0}>
            <div className={"col-xs-12"}>
              <PluginPlaceholder
                {...props}
                key="1"
                isDndQuestion
                pluginContainerName={i18n.t("DragDrop.Question")}
                pluginDefaultContent={[
                  {
                    plugin: "BasicText",
                    initialState: {
                      __i18nKey: "DragDrop.Statement",
                      __suffix: suffix,
                      __text: defaultText,
                    },
                  },
                ]}
                pluginContainer={"Question"}
              />
            </div>
          </div>
          <div style={{ display: "flex", flexWrap: "wrap" }}>{answerElements}</div>
          {props.onAddAnswer ? (
            <button
              type="button"
              className="assessment-add-answer"
              onClick={(e) => {
                e.stopPropagation();
                props.onAddAnswer();
              }}
            >
              + {i18n.t("messages.add_answer")}
            </button>
          ) : null}

          <div
            className={"row feedbackRow"}
            key={-2}
            style={{ display: state.showFeedback ? "block" : "none" }}
          >
            <div
              className={"col-xs-12 feedback"}
              style={{
                color: /* quizColor */ "black",
                borderColor: "#318533",
                backgroundColor: setRgbaAlpha("rgba(39,208,124,0.20)", 0.15),
              }}
            >
              <PluginPlaceholder
                {...props}
                key="-2"
                pluginContainerName={i18n.t("MultipleChoice.Feedback")}
                pluginContainer={"TrueFeedback"}
                pluginDefaultContent={[
                  {
                    plugin: "BasicText",
                    initialState: { __i18nKey: "MultipleChoice.TrueFeedbackMsg" },
                  },
                ]}
              />
            </div>
          </div>
          <div
            className={"row feedbackRow"}
            key={-3}
            style={{ display: state.showFeedback ? "block" : "none" }}
          >
            <div
              className={"col-xs-12 feedback"}
              style={{
                color: /* quizColor */ "black",
                borderColor: "#a31111",
                backgroundColor: setRgbaAlpha("rgba(213,26,26,0.20)", 0.15),
              }}
            >
              <PluginPlaceholder
                {...props}
                key="-3"
                pluginContainerName={i18n.t("MultipleChoice.Feedback")}
                pluginContainer={"FalseFeedback"}
                pluginDefaultContent={[
                  {
                    plugin: "BasicText",
                    initialState: { __i18nKey: "MultipleChoice.FalseFeedbackMsg" },
                  },
                ]}
              />
            </div>
          </div>
        </div>
      );
    },
  };
}
/* eslint-enable react/prop-types */
